import type { RenderContext, RenderField } from "../types.ts";
import { renderChoiceGroup } from "./choice-group.ts";

export const renderRadioGroupField = (
  field: RenderField<"RADIO_GROUP">,
  context: RenderContext,
): HTMLElement => {
  return renderChoiceGroup(field, context);
};
